module.exports = __webpack_public_path__ + "img/team_simon.ea5f8646.jpg";